import jsCookie, { CookieAttributes } from 'js-cookie';

declare global {
  interface Window {
    OptanonActiveGroups?: string[];
    Optanon?: () => void;
  }
}

interface CookieConsent {
  necessary: boolean;
  performance: boolean;
  functional: boolean;
  targeting: boolean;
  social: boolean;
}

export const CookieService = {
  getConsent(): CookieConsent {
    const defaultConsent = {
      necessary: true,
      performance: false,
      functional: false,
      targeting: false,
      social: false,
    };

    if (!window.OptanonActiveGroups || !window.Optanon) {
      return defaultConsent;
    }

    return {
      necessary: window.OptanonActiveGroups.includes('C0001'),
      performance: window.OptanonActiveGroups.includes('C0002'),
      functional: window.OptanonActiveGroups.includes('C0003'),
      targeting: window.OptanonActiveGroups.includes('C0004'),
      social: window.OptanonActiveGroups.includes('C0005'),
    };
  },

  setCookie(name: string, value: string, expires: CookieAttributes): void {
    jsCookie.set(name, value, expires);
  },

  getCookie(name?: string): string | CookieAttributes {
    let cookie;
    if (name) {
      // returns a string with the value
      cookie = jsCookie.get(name);
    } else {
      // returns a object with name and value of the cookie
      cookie = jsCookie.get();
    }
    return cookie;
  },
};
